<template>
  <div class="rewardModal" v-if="reward" id="rewardModal">
    <v-style>
      .modal-reward-header {
      background-image: url({{reward.get('image') || "/images/reward.jpeg"}})
      }
    </v-style>
    <div :class="`modal-reward-header ${map ? 'map':''}`">
      <span class="fhr fhr-arrow-down" @click="closeModal()"></span>
      <span></span>
      <span class="fhr fhr-info"></span>
      <!-- <div v-if="map" @click="map = false" class="image-arrow image-arrow-left">
        <span class="fhr fhr-arrow-left"></span>
      </div>
      <div v-else @click="map = true" class="image-arrow image-arrow-right">
        <span class="fhr fhr-arrow-right"></span>
      </div>-->
    </div>
    <div class="modal-reward-details">
      <section>
        <h5>{{reward.get('name')}}</h5>
        <span v-html="reward.get('description') || $t('components.reward.noDescriptionText')"></span>
      </section>
    </div>
    <div class="btn" role="button">
      <span @click="$emit('buy', $props.reward)" class="btn-main">Assign</span>
    </div>
  </div>
</template>

<script>
import { HTMLModal } from 'modern-modals'
export default {
  name: "RewardView",
  props: ['reward', 'kidsView'],
  mounted() {
    window.rewardModal = new ModernModals.HTMLModal($('#rewardModal'))
  },
  data() {
    return {
      map: false
    }
  },
  methods: {
    closeModal() {
      // The modal is created on the window, the element does not hold it.
      if (window.rewardModal) window.rewardModal.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.image-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  .fhr {
    height: 30px;
    width: 30px;
    display: block;
    background: white;
    &-arrow-left {
      background: black !important;
    }
  }
  &-right {
    left: 90%;
  }
}
#rewardModal {
  height: 100vh;
  text-align: center;
  opacity: 0;
  .btn {
    transition: all 1s;
    display: grid;
    grid-template-columns: 1fr 4fr;
    margin: 20px;
    @supports (-webkit-overflow-scrolling: touch) {
      margin-bottom: 77px;
    }
    &-sub {
      border-radius: var(--modal-radius);
      background: var(--card-bg);
      color: var(--layout-color);
    }
  }
}
.modal {
  max-height: unset;
  display: grid;
  grid-template-rows: 3fr 4fr auto;
  transform: translateY(100vh);
  padding: 0;
  margin: 0;
  border-radius: 0;
  &-reward {
    &-details {
      text-align: center;
      border-radius: var(--modal-radius) var(--modal-radius) 0 0;
      transform: translateY(-32px);
      background: var(--layout-bg);
      color: var(--layout-color);
      padding: 10px;
      display: grid;
      grid-template-rows: auto auto;
      &-heading {
        display: block;
        text-transform: uppercase;
        color: #858585;
        margin: 10px 0;
        &::before,
        &::after {
          //    content: "——————";
          opacity: 0.75;
        }
        &:before {
          padding-right: 5px;
        }
        &:after {
          padding-left: 5px;
        }
      }
    }
    &-header {
      position: relative;
      background-color: #f0f0f0;
      background-position: center;
      background-size: cover;
      border-radius: 0;
      padding: 10px;
      color: white;
      display: grid;
      grid-template-rows: auto 1fr;
      grid-template-columns: auto 1fr auto;

      .fhr {
        --fhr-icon-size: 20px;
        background: white;
      }
    }
    h5 {
      margin: 0;
    }
  }
}
</style>